import Vue from 'vue';
import VueI18n from 'vue-i18n'
import tw from './tw'      // 存放中文語系檔
import en from './en'      // 存放英文語系檔

Vue.use(VueI18n)


// 預設使用的語系
var sys = (navigator.language||navigator.userLanguage||navigator.browserLanguage||navigator.systemLanguage).toLowerCase();
let locale = (sys == 'zh-cn'||sys == 'zh-tw'||sys == 'zh-hk'?'tw':'en' );

// i18n: (key, value) => i18n.t(key, value)

export const i18n = new VueI18n({
  locale: locale,
  messages: {
    'tw': tw,
    'en': en
  }
});
